import * as $ from 'jquery';
import {Global} from "../init-global";
import { TweenLite, TimelineLite, Sine, Bounce, Circ, Elastic, Power2 } from 'gsap';
const activated = [ TweenLite, TimelineLite, Sine, Bounce, Circ, Elastic, Power2 ];


export class RecipeBanner
{
	protected $root: JQuery;
	protected tl:TimelineLite;
    protected $title:JQuery;
    protected $subtitle:JQuery;
    protected $openSign:JQuery;
    protected tlSign:TimelineLite;
    protected imagesLoaded:boolean = false;

	constructor(elem: HTMLElement)
    {
        this.$root = $(elem);
        this.bindUI();
    }

    private bindUI() {
        this.$title    = $('.l-recipe-banner__title', this.$root);
        this.$subtitle = $('.l-recipe-banner__heading p', this.$root);
        this.$openSign = $('.l-recipe-banner__sign-gfx img', this.$root);

        //this.doAnimation();

        this.loadImages();

        let interval: number;
        interval = window.setInterval(() => { 
            if (this.imagesLoaded) {
                this.doAnimation();
                clearInterval(interval);
            }
        }, 10);
    }

    private doAnimation = () => {
        if (typeof this.tl != 'undefined') {
            this.tl.clear();
        }

		this.tl = new TimelineLite({ delay: 0.4, onComplete: () => {
			this.swingSign();
		} });

		this.tl.to(this.$title, 0.25, { opacity: 1, ease: Sine.easeOut})
		.fromTo(this.$title, 0.2, { scale: 0.85 }, { scale: 1, ease: Circ.easeOut }, 0)
		.fromTo(this.$title, 0.4, { y: '+=50' }, { y: '0', ease: Sine.easeOut }, 0)
		.fromTo(this.$subtitle, 0.6, { scale: 1.6 }, { scale: 1, ease: Bounce.easeOut }, 0.4)
		.to(this.$subtitle, 0.4, { opacity: 1, ease: Sine.easeOut }, 0.4);
	}

	private swingSign = () => {
		if (typeof this.tlSign != 'undefined') {
            this.tlSign.clear();
        }

        this.tlSign = new TimelineLite({ delay: 0.2 });

        this.tlSign.to(this.$openSign, 1, {rotation:-30, ease:Power2.easeInOut})
 		.to(this.$openSign, 1, { rotation: 20, repeat: -1, yoyo:true, ease:Power2.easeInOut});
	}

	private loadImages = () => {
      // Load the images
      if (!this.imagesLoaded) { 
        let imgsToLoad:any[] = [];
        imgsToLoad.push(this.$title.attr('data-background'), this.$subtitle.attr('data-background'), this.$openSign.attr('srcset'));
        var remainingLoads:number = imgsToLoad.length;

        for (let i = 0; i < imgsToLoad.length; i++) {
          let img:HTMLImageElement = document.createElement('img');
          img.src = imgsToLoad[i];

          if (img.complete) {
            --remainingLoads;
            if (remainingLoads <= 0) 
                this.imagesLoaded = true;
          }
          else
            $(img).on('load', () => { 
              --remainingLoads;
              if (remainingLoads <= 0) 
                this.imagesLoaded = true;
           });
        }
      }
    }
}